import type { TicketRequestCategoryI } from 'declarations/interfaces/ticketRequestCategories';
import type { TicketRequestSubcategoryI } from 'declarations/interfaces/ticketRequestSubcategories';

export function parseRequestCategoryId(raw: unknown): number | undefined {
  if (typeof raw === 'number' && !Number.isNaN(raw)) {
    return raw;
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (t === '') {
      return undefined;
    }
    const n = Number(t);
    return Number.isNaN(n) ? undefined : n;
  }
  return undefined;
}

export function requestCategoryQualifiesForCreationAttachments(
  categories: TicketRequestCategoryI[] | undefined,
  categoryId: number | undefined | null
): boolean {
  if (categoryId == null || Number.isNaN(Number(categoryId)) || !categories?.length) {
    return false;
  }
  return categories.some(c => Number(c.id) === Number(categoryId));
}

export function categoryAllowsAttachments(
  categories: TicketRequestCategoryI[] | undefined,
  categoryId: number | undefined | null
): boolean {
  if (categoryId == null || Number.isNaN(Number(categoryId)) || !categories?.length) {
    return false;
  }
  const cat = categories.find(c => c.id === categoryId);
  return Boolean(cat?.requiresAttachment);
}

export function subcategoryAllowsAttachments(
  subcategories: TicketRequestSubcategoryI[] | undefined,
  subcategoryId: number | undefined | null
): boolean {
  if (subcategoryId == null || Number.isNaN(Number(subcategoryId)) || !subcategories?.length) {
    return false;
  }
  const sub = subcategories.find(s => s.id === subcategoryId);
  return Boolean(sub?.requiresAttachment);
}

export function categoryOrSubcategoryAllowsAttachments(
  categories: TicketRequestCategoryI[] | undefined,
  categoryId: number | undefined | null,
  subcategories: TicketRequestSubcategoryI[] | undefined,
  subcategoryId: number | undefined | null
): boolean {
  return (
    categoryAllowsAttachments(categories, categoryId) ||
    subcategoryAllowsAttachments(subcategories, subcategoryId)
  );
}

export function anyBulkFormCategoryAllowsAttachments(
  categories: TicketRequestCategoryI[] | undefined,
  categoryRows: readonly string[],
  formRecord: Record<string, unknown>
): boolean {
  for (const rowId of categoryRows) {
    const categoryId = parseRequestCategoryId(formRecord[`requestCategoryId-${rowId}`]);
    if (requestCategoryQualifiesForCreationAttachments(categories, categoryId)) {
      return true;
    }
  }
  return false;
}

export function anyBulkRowCategoryAllowsAttachments(
  categories: TicketRequestCategoryI[] | undefined,
  rowIds: readonly string[],
  rowCategoryIdByRowId: Record<string, number | undefined>
): boolean {
  for (const rowId of rowIds) {
    if (requestCategoryQualifiesForCreationAttachments(categories, rowCategoryIdByRowId[rowId])) {
      return true;
    }
  }
  return false;
}
